
const digest = 'a6463a59e7d3e1417c035a7983e9a4a9e5fcbc3340f7b39f8abdc95c7ff6927d';
const classes = {"wrapper":"_wrapper_h1veh_1","list":"_list_h1veh_7","button":"_button_h1veh_13"};
const css = `._wrapper_h1veh_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
._wrapper_h1veh_1 ._list_h1veh_7 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_h1veh_1 ._button_h1veh_13 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  